// KAN-892: stamped at build time (scripts/build.js, scripts/build-local.sh).
export const APP_VERSION = process.env.REACT_APP_APP_VERSION || 'dev';
export const BUILD_CODE = process.env.REACT_APP_BUILD_VERSION || 'dev';

/** "App version 2026.10.19.2045 · a1b2c3d" (localized). */
export function appVersionLine(intl, version = APP_VERSION, build = BUILD_CODE) {
  return intl.formatMessage(
    { id: 'account.appVersion.line', defaultMessage: 'App version {version} · {build}' },
    { version, build },
  );
}
